import qs from 'qs';
import { OPPORTUNITY_STATUS_MAP, SINGLE_STATUS_MAP } from '../constants/opportunityStatuses';
import { TOKEN_PAYMENT_STATUS, TOKEN_PAYMENT_STATUS_MAP } from '../constants/tokenPaymentStatuses';

// CPI-1281: the Bookings-page filters a queued Excel export carries. Same names as the URL of
// the Bookings list and as the query book-api's POST /opportunity/export/ accepts, so the export
// reproduces the list the user was looking at.
export const VN_BOOKING_EXPORT_FILTER_KEYS = ['group_status', 'sr_status', 'sr_code', 'customer_name', 'token_status_id'];

export const VN_BOOKING_EXPORTS_PATH = '/opportunities/exports/';

// exportFiltersFromQuery keeps only the allow-listed filters from a decoded Bookings-list query,
// trimmed, with empties and the default pending_payment token tab dropped (it is the list's
// default view, not a token-primary filter).
export const exportFiltersFromQuery = (query = {}) => VN_BOOKING_EXPORT_FILTER_KEYS.reduce(
  (acc, key) => {
    const raw = query[key];
    const value = typeof raw === 'string' ? raw.trim() : '';
    if (!value) return acc;
    if (key === 'token_status_id' && value === TOKEN_PAYMENT_STATUS.PENDING_PAYMENT) return acc;
    return { ...acc, [key]: value };
  },
  {},
);

export const exportsPagePath = (filters) => {
  const search = qs.stringify(filters || {});
  return search ? `${VN_BOOKING_EXPORTS_PATH}?${search}` : VN_BOOKING_EXPORTS_PATH;
};

// exportFiltersSummary renders stored filters for the exports table. The first part is always
// the Bookings tab the export was taken from (All Bookings when none was applied), as a bare
// chip with no label; Booking ID and Purchaser Name follow as "Label: value" chips. Labels
// resolve in the caller's default (screens) namespace; tab and status texts are constants
// texts, so they go through `ns`. Unknown values fall back raw.
export const exportFiltersSummary = (filters = {}, t, ns) => {
  const labelFor = (map, value) => (map[value] ? t(map[value].text, ns) : value);
  const parts = [];
  const f = filters || {};
  if (f.token_status_id) {
    parts.push({ key: 'token_status_id', label: null, value: labelFor(TOKEN_PAYMENT_STATUS_MAP, f.token_status_id) });
  } else if (f.sr_status) {
    parts.push({ key: 'sr_status', label: null, value: labelFor(SINGLE_STATUS_MAP, f.sr_status) });
  } else if (f.group_status && f.group_status !== 'total') {
    parts.push({ key: 'group_status', label: null, value: labelFor(OPPORTUNITY_STATUS_MAP, f.group_status) });
  } else {
    parts.push({ key: 'group_status', label: null, value: t('All Bookings', ns) });
  }
  if (f.sr_code) parts.push({ key: 'sr_code', label: t('Booking ID'), value: f.sr_code });
  if (f.customer_name) parts.push({ key: 'customer_name', label: t('Purchaser Name'), value: f.customer_name });
  return parts;
};

// progressPercent turns book-api's "done/total" into 0-100, tolerating the "0/0" a freshly claimed
// row carries (NaN would otherwise reach the progress bar).
export const progressPercent = (progress) => {
  if (!progress || typeof progress !== 'string' || progress.indexOf('/') === -1) return 0;
  const [done, total] = progress.split('/').map(v => parseInt(v, 10));
  if (!total || Number.isNaN(done) || Number.isNaN(total)) return 0;
  return Math.max(0, Math.min(100, Math.floor((done / total) * 100)));
};



// WEBPACK FOOTER //
// ./src/utils/vnBookingExport.js